import React from 'react'
import { Provider } from 'react-redux'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/analytics'
import 'firebase/functions'
import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import { ReactReduxFirebaseProvider, firebaseReducer } from 'react-redux-firebase'
import { createFirestoreInstance, firestoreReducer, reduxFirestore } from 'redux-firestore' // <- needed if using firestore
import createSagaMiddleware from 'redux-saga'

import { reducer as userReducer } from 'logic/user/user.reducer'
import firebaseConfig from 'modules/firebase/config.json'
import allSagas from 'modules/redux/sagas/rootSaga'

// react-redux-firebase config
const rrfConfig = {
    enableLogging: process.env.NODE_ENV === 'development',
    userProfile: 'users',
    useFirestoreForProfile: true, // Firestore for Profile instead of Realtime DB
}

// Initialize firebase instance
firebase.initializeApp(firebaseConfig)

// Initialize other services on firebase instance
firebase.firestore()
firebase.analytics()
firebase.functions()
firebase.auth().useDeviceLanguage()

// if(window.location.hostname === 'localhost') {
//   console.log("testing locally -- hitting local functions and firestore emulators");
// firebase.functions().useFunctionsEmulator('http://localhost:5000');
//   firebase.firestore().settings({
//     host: 'localhost:8080',
//     ssl: false
//   });
//   firebase.auth().useEmulator("http://localhost:9099");
// }

// Reducers
const allReducers = {
    firebase: firebaseReducer,
    firestore: firestoreReducer,
    user: userReducer,
}

// Middlewares
const sagaMiddleware = createSagaMiddleware()
const allMiddlewares = [sagaMiddleware]

// Enhancers
const composeEnhancers =
    typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
        })
        : compose

// Store
export const store = createStore(
    combineReducers(allReducers),
    composeEnhancers(applyMiddleware(...allMiddlewares), reduxFirestore(firebase))
)

// Saga
sagaMiddleware.run(allSagas)

// Firebase props
const rrfProps = {
    firebase,
    config: rrfConfig,
    dispatch: store.dispatch,
    createFirestoreInstance, // <- needed if using firestore
}

// HOC
export default ({ children }) => {
    return (
        <Provider store={store}>
            <ReactReduxFirebaseProvider {...rrfProps}>{children}</ReactReduxFirebaseProvider>
        </Provider>
    )
}
